import React, { useEffect, useState } from "react";
import {
    Accordion,
    Col,
    Dropdown,
    Row,
    Spinner,
} from "react-bootstrap";
import { CompetencyItemContainer } from "./CompetencyItemContainer";
import CustomActionButton from "Components/Common/CustomActionButton";
import { useDomainCompetencies } from "@/hooks/useDomainCompetencies";
import { useStandardCompetencies } from "@/hooks/standard-competency";
import PageTitle from "Components/Common/PageTitle";
import ModalUpload from "./ModalUpload";
import { DomainStandardCompetenciesModal } from "./DomainStandardCompetenciesModal";
import { Utils } from "@/common/utils";
import { Link } from "react-router-dom";

const CompetencyMappingContainer = () => {

    const [baseUrl, setBaseUrl] = useState("");

    const {
        items: domainItems,
        addItem,
        deleteItem,
        toggleEnabled: toggleDomainEnabled,
        isLoading: isDomainLoading,
        isRequestLoading: isDomainRequestLoading,
        updateNameAndSave,
        openUploadModal,
        setOpenUploadModal,
        openDomainStandardCompetenciesModal,
        setOpenDomainStandardCompetenciesModal,
        mutate: mutateDomainCompetencies,
        toggleOpen
    } = useDomainCompetencies();

    const {
        items: standardItems,
        toggleSchoolEnabled,
        isLoading: isStandardLoading,
        mutate: mutateStandardCompetencies
    } = useStandardCompetencies();

    useEffect(() => {
        const url = Utils.getLinkBase();
        setBaseUrl(url);
    }, []);


    return (
        <div className="card-layout">
            <PageTitle pageTitle={"Competency Catalog"} />
            <Row>
                <Col md={12} lg={6} className="title">
                    <h3>Competency Catalog</h3>
                </Col>
                <Col className="create-button">
                    <span>
                        <Link to={`${baseUrl}/competency-matching`}>
                            See unmapped competencies
                        </Link>
                    </span>
                    <Dropdown>
                        <Dropdown.Toggle
                            as={CustomActionButton}
                            id="dropdown-custom-components"
                        >
                            Add Mapping Group
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item
                                eventKey="1"
                                onClick={() => setOpenDomainStandardCompetenciesModal(true)}
                            >
                                Add from list
                            </Dropdown.Item>
                            <Dropdown.Item eventKey="2" onClick={() => addItem(null)}>
                                Create Manually
                            </Dropdown.Item>
                            <Dropdown.Item eventKey="3" onClick={() => {
                                setOpenUploadModal(!openUploadModal);
                            }}>
                                Import from a file
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </Col>
            </Row>
            <div className="divider" />
            <Accordion className="list">
                {isDomainLoading || isDomainRequestLoading ? (
                    <div className="text-center">
                        <Spinner animation="border" variant="primary" />
                    </div>
                ) : domainItems?.length ? (
                    domainItems.map((item) => (
                        <CompetencyItemContainer
                            key={item.ruuid}
                            item={item}
                            addItem={addItem}
                            deleteItem={deleteItem}
                            toggleEnabled={toggleDomainEnabled}
                            updateNameAndSave={updateNameAndSave}
                            toggleOpen={toggleOpen}
                        />
                    ))
                ) : (
                    <p className="text-center text-muted">No domain competencies found.</p>
                )}
            </Accordion>
            <ModalUpload show={openUploadModal} onClose={() => setOpenUploadModal(!openUploadModal)} />
            <DomainStandardCompetenciesModal
                show={openDomainStandardCompetenciesModal}
                onClose={(changesApplied) => {
                    setOpenDomainStandardCompetenciesModal(false);
                    if (changesApplied) {
                        mutateDomainCompetencies(undefined, true);
                        mutateStandardCompetencies(undefined, true);
                    }
                }}
                competencies={standardItems}
                toggleEnabled={toggleSchoolEnabled}
                isLoading={isStandardLoading}
            />
        </div>
    );
};

export default CompetencyMappingContainer;
